import styled from 'styled-components';
import {GLOBAL_COLORS} from '../../util/colors';
import WBIcon from './WBIcon';

export const Content = styled.div<{width?: number; backgroundColor?: string}>`
  width: ${props => (props.width ? props.width + 'px' : 'fit-content')};
  padding: 4px 0;
  background: ${props =>
    props.backgroundColor ? props.backgroundColor : 'rgb(34, 34, 34)'};
  border-radius: 2px;
`;

export const Item = styled.div<{hovered?: boolean}>`
  color: white;
  padding: 8px 24px 8px 12px;
  font-size: 14px;
  line-height: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  background: ${props =>
    props.hovered ? GLOBAL_COLORS.primary.toString() : 'none'};
  word-break: break-word;
`;

export const ItemIcon = styled(WBIcon)`
  margin-right: 8px;
  font-size: 16px;
  width: 16px;
  flex-shrink: 0;
`;
